// src/Components/ChatHistoryModal/index.js
import React from 'react';
import { X, Calendar } from 'lucide-react';
import { useTheme } from '../../Context/ThemeContext';
import './index.css';

const HistoryDatesModel = ({ isOpen, onClose, dates, onDateSelect }) => {
  const { isDarkMode } = useTheme();
  if (!isOpen) return null;

  const safeDates = Array.isArray(dates) ? dates : [];

  const handleDateCardClick = (dateStr) => {
    onDateSelect(dateStr);
    onClose(); // Close modal after selection
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className={`modal-content ${isDarkMode ? 'dark-mode' : 'light-mode'}`} onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3>History</h3>
          <button className="modal-close-button" onClick={onClose} aria-label="Close history dates modal">
            <X size={22} />
          </button>
        </div>
        {safeDates.length > 0 ? (
          <div className="dates-grid">
            {safeDates.map((item) => (
              <div
                key={item.session_date} // session_date should be unique "YYYY-MM-DD"
                className={`date-card`}
                tabIndex={0}
                onClick={() => handleDateCardClick(item.session_date)}
                onKeyPress={(e) => { if (e.key === 'Enter') handleDateCardClick(item.session_date); }}
                role="button"
              >
                <Calendar size={16} className="date-card-icon" />
                <span className="date-card-text">
                  {new Date(item.session_date + "T00:00:00").toLocaleDateString('en-US', {
                    month: 'long',
                    day: 'numeric',
                    year: 'numeric'
                  })}
                  {new Date(item.session_date).toDateString() === new Date().toDateString() && " (Today)"}
                </span>
              </div>
            ))}
          </div>
        ) : <p className="no-dates-message">No historical chat dates found.</p>}
      </div>
    </div>
  );
};

export default HistoryDatesModel;